import API from 'services/TAPS_API/index';

export default function getOverpaymentsPdfName(notificationId) {
  return API.request({
    method: 'GET',
    url: `/overpayments/pdf`,
    params: {
      notificationId,
    },
  });
}
